import Component from './src/main.vue';

Component.install = function install(_Vue) {
  _Vue.component(Component.name, Component);
};

export default Component;
